import { object } from 'common/helpers'


export const initialState = {
  vacancies: [],
}

export const setVacancies = (state, payload) =>
  object.set(state, 'vacancies', payload)
